import React from 'react'
import {PaymentButton, PaymentNoPayment, PaymentPayIcon, PaymentSaveInfoContainer} from './style'
import {Alert, Box, Grid, Typography} from '@mui/material';
import {Link as RouterLink} from 'react-router';
import SinglePaymentMethod from './SinglePaymentMethod';
import {determinePaymentImage} from "../../util/PaymentUtils";
import EmailVerifyGuardTooltip from "../../components/notifications/EmailVerifyGuardTooltip";
import {hasOwnerAccess} from "../../util/AccountUtils";

const BookingPaymentInfo = ({ account, paymentMethods, showPaymentModal, selectedPaymentMethod, setSelectedPaymentMethod }) => {
    // Not blocking: the charge still goes through. The balance check is skipped until the buyer re-authorizes.
    const selectedNeedsReauth = paymentMethods?.some((method) => method.id === selectedPaymentMethod && method.plaidReauthRequired);

    return (
        <Box>
            <Grid container justifyContent='space-between' alignItems='center'>
                <Typography variant={'h5'} color={'textPrimary'}>
                    Pay With
                </Typography>
                {hasOwnerAccess(account) &&
                <EmailVerifyGuardTooltip
                    disabled={!account?.emailVerified}
                    disabledReason={"Please verify your email address to add a payment method."}
                >
                  <PaymentButton onClick={showPaymentModal} variant='contained' color='secondary' disabled={!account.emailVerified}>
                    <PaymentPayIcon />
                    ADD PAYMENT
                  </PaymentButton>
                </EmailVerifyGuardTooltip>
                }
            </Grid>
            {paymentMethods?.length > 0 ? <PaymentSaveInfoContainer>
                {paymentMethods.map((paymentMethod) => {
                    return (
                        <SinglePaymentMethod
                          key={paymentMethod.id}
                          img={determinePaymentImage(paymentMethod)}
                          cardInfo={`...` + paymentMethod.lastFour + (paymentMethod.nickName ? ` (${paymentMethod.nickName})` : '')}
                          isSelect={selectedPaymentMethod === paymentMethod.id}
                          id={paymentMethod.id}
                          onClick={setSelectedPaymentMethod}
                        />
                    )
                })}
            </PaymentSaveInfoContainer> : <PaymentNoPayment>
                No payment method added yet
            </PaymentNoPayment>}
            {selectedNeedsReauth &&
                <Alert severity="warning" sx={{mt: 2}}>
                    This bank needs you to log in again. You can still book with it, but please re-authorize it.{' '}
                    <RouterLink to={'/account/payment-methods'}>Go to Payment Methods</RouterLink>
                </Alert>
            }

        </Box>
    )
}

export default BookingPaymentInfo
